export default __webpack_public_path__ + "static/media/logout.7a831b5e.svg";